import { Link } from "gatsby";
import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";

function IndexPage() {
  return (
    <Layout>
      <SEO
        keywords={[`rabbi`, `mayoza`, `rabbi fijar mayoza`, `pollycarpus`]}
        title="Home"
      />
      <div className="flex-1 w-full bg-white">
        <section className="sm:text-left lg:text-left px-4 py-8 mx-auto md:px-8 md:py-16 max-w-5xl">
          <h1 className="mb-4 text-2xl tracking-tight font-semibold text-gray-900 sm:text-3xl md:text-4xl">
            <span className="block xl:inline">Hi, I am Rabbi Fijar Mayoza, a lifetime learner, tech savvy and enthusiast.</span>
          </h1>
          <h1 className="mb-4 text-2xl tracking-tight font-semibold text-gray-900 sm:text-3xl md:text-4xl">
            <span className="block xl:inline">I love to convert ideas into valuable products that solve complex real problems.</span>
          </h1>
          <div className="mt-5 sm:mt-8 sm:flex sm:justify-start lg:justify-start">
            <div className="rounded-md shadow">
              <Link 
                className="w-full flex items-center justify-center px-8 py-3 border-2 text-sm border-black font-medium rounded-md text-gray-700 bg-white hover:bg-blue-700 hover:text-white hover:border-transparent md:py-4 md:text-lg md:px-10"
                to="/about">
                Get to know more
              </Link>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default IndexPage;
